module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_b1_dark.7da5efa0.svg";